import React from 'react';
import { ExperienceContext } from './ExperienceContext';
export function Experience(_ref) {
  var children = _ref.children,
    name = _ref.name;
  return /*#__PURE__*/React.createElement(ExperienceContext.Provider, {
    value: name
  }, children);
}